(function( $ ) {
    $.fn.custRating = function() {
        if (this.length > 1) {
            this.each(function() { $(this).custRating() });
            return this;
        }
        // Elements
        var container      = $(this);
        var statsContainer = container.find('.StarSelector');
        var stars          = $(this).find('.star-selector');
        var value          = $(this).find(".rating_note_input").val();
        var selectedStar   = null;

        selectedStar = statsContainer.find('[data-value="'+value+'"]');

        statsContainer.children().removeClass( function (index, css) {
            return (css.match (/(^|\s)starSel\S+/g) || []).join(' ');
        });

        selectedStar.addClass( 'starSel'+ value );
        selectedStar.nextAll().addClass( 'starSel'+ value );

        stars.click(function(e) {
            selectedStar = $(this);
            value = selectedStar.data('value');
            container.find(".rating_note_input").val(value);
            statsContainer.children().removeClass( function (index, css) {
                return (css.match (/(^|\s)starSel\S+/g) || []).join(' ');
            });
            selectedStar.addClass( 'starSel'+ value );
            selectedStar.nextAll().addClass( 'starSel'+ value );
            return false;
        });
    };
}( jQuery ));
